<div *ngIf="availableCredits && availableCredits < 60" class="twc-message-box twc-message-box-warning twc-mb-3">
    {{'REPORTS.WARNING_LOW_CREDITS' | translate}}
</div>

<ng-container *ngIf="estimation; else loading">
    <div class="twc-d-flex">
        <span class="twc-body flex-50 font-bold">{{'WIZARD.ESTIMATION_UNITS' | translate}}:</span>
        <span *ngIf="estimation.processingCredits;else noData" class="twc-body flex-50">{{estimation.processingCredits|
            number : '1.2-2'}}</span>
    </div>

    <div *ngIf="processingTime" class="twc-d-flex">
        <span class="twc-body flex-50 font-bold">{{'WIZARD.ESTIMATION_TIME' | translate}}:</span>
        <span class="twc-body flex-50">{{processingTime | date:'HH:mm:ss'}}</span>
    </div>
</ng-container>

<div class="twc-d-flex">
    <span class="twc-body flex-50 font-bold">{{ 'WIZARD.AVAILABLE_CREDITS' | translate}}:</span>
    <span *ngIf="creditsAfterProcessing;else noData" class="twc-body flex-50"
        [ngClass]="{'insufficient-credits': creditsAfterProcessing && creditsAfterProcessing < 0}">
        {{creditsAfterProcessing | number : '1.2-2'}}
    </span>
</div>

<ng-template #loading>
    <twc-loader></twc-loader>
</ng-template>

<ng-template #noData>
    <span class="twc-body flex-50">-</span>
</ng-template>